var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, Button, Flex, Icon, Text } from '@chakra-ui/react';
import React from 'react';
import { BaseDialog, BaseDialogState } from '@/app/UIComponents/BaseDialog';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import { MdDelete } from '@react-icons/all-files/md/MdDelete';
import { FileUploadDialog, FileUploadDialogState } from './FileUploadDialog';
export class VersionDialogState {
    constructor() {
        this.baseDialogState = new BaseDialogState();
        this.versions = [];
        this.uploaderState = new FileUploadDialogState();
        this.letrid = "";
        makeObservable(this);
        this.baseDialogState.setHeaderLabel("Versions");
        this.baseDialogState.setHideFooter(true);
        this.uploaderState.singleFileMode = true;
        this.uploaderState.fileUploadedCb = (uploaded) => {
            var _a;
            const nversion = {
                name: uploaded.filename,
                size: uploaded.size,
                acesskey: uploaded.accesskey,
                versionnumber: this.versions.length + 1,
                filid: uploaded.fileid,
                boxid: uploaded.databoxid,
                isDownloadable: uploaded.isDownloadable,
                creatorid: ''
            };
            this.addVerion(nversion);
            this.uploaderState.setOpen(false);
            this.uploaderState.clear();
            (_a = this.versionaddedcb) === null || _a === void 0 ? void 0 : _a.call(this, nversion);
        };
    }
    addVersions(vrs) {
        vrs.forEach((vr) => this.addVerion(vr));
    }
    addVerion(ver) {
        this.versions.push(ver);
    }
    setOpen(open) {
        this.baseDialogState.setOpen(open);
    }
    clear() {
        this.versions = [];
    }
    removeVersion(ver) {
        const index = this.versions.indexOf(ver);
        if (index > -1) {
            this.versions.splice(index, 1);
        }
    }
    setShowUploader(show) {
        this.uploaderState.letrid = this.letrid;
        this.uploaderState.setOpen(show);
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], VersionDialogState.prototype, "versions", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], VersionDialogState.prototype, "addVerion", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], VersionDialogState.prototype, "clear", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], VersionDialogState.prototype, "removeVersion", null);
let VersionDialog = class VersionDialog extends React.Component {
    constructor(prop) {
        super(prop);
    }
    addVersion() {
        this.props.state.setShowUploader(true);
    }
    buildVersion(v, index) {
        return React.createElement(Flex, { align: 'center', backgroundColor: index % 2 === 0 ? '#e0e0e0' : '#ffffff', key: v.boxid, height: '50px', borderBottomColor: 'lightgray', borderBottomWidth: '1px' },
            React.createElement(Text, { w: '80%' }, v.name + " (" + v.versionnumber + ")"),
            React.createElement(Box, { w: '20%', alignItems: 'flex-end' },
                React.createElement(Icon, { fontSize: '20px', as: MdDelete })));
    }
    renderUI() {
        return React.createElement(Box, null,
            !this.props.hideNewVersion && React.createElement(Button, { onClick: () => this.addVersion() }, "Add Version"),
            React.createElement(Box, { mt: '10px', minH: '50px', maxH: this.props.bodyHeight, overflowY: 'auto' }, this.props.state.versions.slice().sort((v1, v2) => v1.versionnumber - v2.versionnumber).reverse()
                .map((v, index) => this.buildVersion(v, index))));
    }
    render() {
        return React.createElement(React.Fragment, null,
            React.createElement(FileUploadDialog, { state: this.props.state.uploaderState }),
            React.createElement(BaseDialog, { body: this.renderUI(), state: this.props.state.baseDialogState }));
    }
};
VersionDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], VersionDialog);
export { VersionDialog };
